/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Friday, 5th April 2019
* 
* Manages the state of the Device Store.
* Provides the objects and methods to change state based on device characteristics.
*/
import { observable, decorate, action, autorun, configure } from 'mobx';
import Fingerprint2 from 'fingerprintjs2';
import Parser from 'ua-parser-js';
configure({ enforceActions: 'observed' });

export default class DeviceStore {
  options = { excludes: { fonts: true } };
  fingerprint = {};
  thumbprint = '';
  language = '';
  timezone='';
  timezoneOffset = '';
  userAgent = '';
  browser = {};
  engine = {};
  os = {};
  screenResolution = '';
  touchSupport = false;
  devices = [];
  plugins = '';
  constructor(rootStore) {
    this.root = rootStore;
    autorun(() => this.collectDetails());
  }

  collectDetails = () => {
    Fingerprint2.get(this.options, (fingerprint) => {
      this.thumbprint = Fingerprint2.x64hash128(fingerprint.join(''), 31);
      const parser = new Parser.UAParser();
      // Set fingerprint id
      this.fingerprint = fingerprint;

      // Map fingerprint details to Device Store
      fingerprint.map(print => {
        // Language
        if (print.key === 'language') {
          this.language = print.value;
        }
        // Timezone
        if (print.key === 'timezone') {
          this.timezone = print.value;
        }
        // Timezone Offset
        if (print.key === 'timezoneOffset') {
          this.timezoneOffset = print.value;
        }
        // User Agent & Browser, Engine, OS
        if (print.key === 'userAgent') {
          parser.setUA = print.value;
          this.userAgent = print.value;
          this.browser = parser.getBrowser();
          this.engine = parser.getEngine();
          this.os = parser.getOS();
        }
        // Touch Support
        if (print.key === 'touchSupport') {
          this.touchSupport = print.value[1];
        }
        // Screen Resolution
        if (print.key === 'screenResolution') {
          this.screenResolution = print.value;
        }
        // Device, Devices (Audio, Input, etc.)
        if (print.key === 'enumerateDevices') {
          try {
            print.value.map(device => {
              const d = device.split(';');
              this.devices.push({
                id: d[0],
                gid: d[1],
                type: d[2]
              });
              return null;
            });
          }
          catch (error) {
            // Error occurred
            // Device unable to support print.value object.
          }
        }
        // Plugins
        if (print.key === 'plugins') {
          this.plugins = print.value;
        }
        return null;
      });
    });
  }
}
decorate(DeviceStore, {
  thumbprint: observable,
  language: observable,
  timezone: observable,
  timezoneOffset: observable,
  collectDetails: action,
});
